import { Brand } from '@blade/std-lib'

export const ReferralCodeTypeId = 'tradebot-tma/ReferralCode'
// eslint-disable-next-line @typescript-eslint/no-redeclare
export type ReferralCodeTypeId = typeof ReferralCodeTypeId

export type ReferralCode = Brand.Branded<string, ReferralCodeTypeId>
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ReferralCode = Brand.nominal<ReferralCode>()

export const InviteCodeTypeId = 'tradebot-tma/InviteCode'
// eslint-disable-next-line @typescript-eslint/no-redeclare
export type InviteCodeTypeId = typeof InviteCodeTypeId
export type InviteCode = Brand.Branded<string, InviteCodeTypeId>
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const InviteCode = Brand.nominal<InviteCode>()
